export default __webpack_public_path__ + "static/media/UserGuide_sv_SE.92c18dbb.pdf";